module.exports = "/images/evidence-icon.svg?c051912f66c2a7adb6037982bf0fcb08";